import React from 'react';
import { ServiceForm } from 'shared/ui';
import { BookingApi } from 'shared/api';
import { businessStore } from 'entities/index';
import { IServicesCard } from 'shared/api/booking/interfaces/services-list.interface';

interface ICreateServiceProps {
  onClose?: () => void;
  onSuccess?: (message: string) => void;
  initialData?: IServicesCard;
}

export const CreateService: React.FC<ICreateServiceProps> = ({
  onClose,
  onSuccess,
  initialData,
}) => {
  const pointId = businessStore.pointId;

  const handleSubmit = async (data: any) => {
    if (!pointId) return;
    await BookingApi.createService({
      ...data,
      businessId: businessStore.businessId,
      pointId,
    });
    businessStore.initServicesList(pointId);
    onSuccess?.('Услуга успешно создана');
    onClose?.();
  };

  return (
    <ServiceForm
      onSubmit={handleSubmit}
      onClose={onClose}
      initialData={initialData}
      isDuplicate={!!initialData}
    />
  );
};
